import {Injectable} from '@angular/core';

@Injectable()
export class RouterStateSpinnerService {

  state = {label: ''};
  transitionStart = function() {
    // console.log("TransStart:",);

    this.state.label = 'loading';
  };
  transitionEnd = function() {
    this.state.label = 'loaded';
    setTimeout(() => {
      this.state.label = '';
    }, 1500);
  };
  transitionError = function() {
    this.state.label = 'error';
  };

  constructor() {
  }


}
